var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoGerenciarProduto01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1450",
    d: "M33.3,15.8h-1.8c-0.2-0.7-0.9-1.3-1.7-1.3H28V9.9c0-0.2-0.1-0.3-0.2-0.4L14.5,1.8c-0.2-0.1-0.3-0.1-0.5,0 L0.8,9.5C0.7,9.6,0.6,9.7,0.6,9.9v15.3c0,0.2,0.1,0.3,0.2,0.4l13.2,7.6c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.3-0.1l7-4v2.9 c0,1.2,0.9,2.1,2.1,2.1c0,0,0,0,0,0h9.7c1.2,0,2.1-0.9,2.1-2.1c0,0,0,0,0,0V17.9C35.4,16.7,34.5,15.8,33.3,15.8z M29.9,15.5 c0.4,0,0.7,0.3,0.7,0.7v0c0,0.4-0.3,0.7-0.7,0.7H27c-0.4,0-0.7-0.3-0.7-0.7v0c0-0.4,0.3-0.7,0.7-0.7H29.9z M14.3,2.8L19.8,6 L7.6,13.1L2.1,9.9L14.3,2.8z M13.8,32L1.6,24.9V10.8l12.3,7.1V32z M14.3,17l-5.8-3.3l12.2-7.1l5.8,3.3L14.3,17z M21.5,17.9v10.2 L14.8,32V17.8L27,10.8v3.7h0c-0.8,0-1.4,0.5-1.7,1.3h-1.8C22.5,15.8,21.5,16.7,21.5,17.9C21.5,17.9,21.5,17.9,21.5,17.9L21.5,17.9z  M34.4,32.1c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0,0,0h-9.7c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0V17.9c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0 h1.8c0.2,0.7,0.9,1.2,1.6,1.2h2.8c0.7,0,1.4-0.5,1.6-1.2h1.8c0.6,0,1.1,0.5,1.1,1.1L34.4,32.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1451",
    d: "M24.2,22.9h0.5c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5h0v-1.3h1.4c0.1,0.2,0.3,0.3,0.5,0.3 c0.3,0,0.5-0.2,0.5-0.5v-0.3c0-0.3-0.2-0.5-0.5-0.5h-2.3c-0.3,0-0.5,0.2-0.5,0.5c0,0,0,0,0,0v2.3C23.7,22.7,23.9,22.9,24.2,22.9 C24.2,22.9,24.2,22.9,24.2,22.9L24.2,22.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1452",
    d: "M24.2,27.4h2.3c0.3,0,0.5-0.2,0.5-0.5v-2.3c0-0.3-0.2-0.5-0.5-0.5h-2.3c-0.3,0-0.5,0.2-0.5,0.5v2.3 C23.7,27.2,23.9,27.4,24.2,27.4z M24.7,25.1H26v1.3h-1.3V25.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1453",
    d: "M24.7,30.9L24.7,30.9l0-1.3H26c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5c0,0,0,0,0,0v-0.5 c0-0.3-0.2-0.5-0.5-0.5h-2.3c-0.3,0-0.5,0.2-0.5,0.5v2.3c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0h0.5c0.3,0,0.5-0.2,0.5-0.5 C25.2,31.1,25,30.9,24.7,30.9L24.7,30.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1454",
    d: "M27.7,20.2l-1.4,1.4l-0.4-0.4c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7l0.8,0.8 c0.2,0.2,0.5,0.2,0.7,0l1.8-1.8c0.2-0.2,0.2-0.5,0-0.7C28.2,20,27.9,20,27.7,20.2C27.7,20.2,27.7,20.2,27.7,20.2L27.7,20.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1455",
    d: "M27.7,29.3l-1.4,1.4l-0.4-0.4c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7l0.8,0.8 c0.2,0.2,0.5,0.2,0.7,0l1.8-1.8c0.2-0.2,0.2-0.5,0-0.7C28.2,29.1,27.9,29.1,27.7,29.3C27.7,29.3,27.7,29.3,27.7,29.3L27.7,29.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1456",
    d: "M32.7,20.8h-3.1c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h3.1c0.3,0,0.5-0.2,0.5-0.5 C33.2,21,33,20.8,32.7,20.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1457",
    d: "M32.7,25.3h-3.1c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h3.1c0.3,0,0.5-0.2,0.5-0.5 C33.2,25.5,33,25.3,32.7,25.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1458",
    d: "M32.7,29.8h-3.1c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h3.1c0.3,0,0.5-0.2,0.5-0.5 C33.2,30,33,29.8,32.7,29.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGerenciarProduto01);
export default __webpack_public_path__ + "static/media/ico-gerenciar-produto-01.b7c1fcbfa02e11786d41d2e7a8b96134.svg";
export { ForwardRef as ReactComponent };